import React from 'react';
import { CreditCard, Check } from 'lucide-react';
import FormField, { fieldClass } from './FormField';
import { PNR_LENGTH, digitsOnly } from '../../utils/bookingValidation';

/**
 * PNR / ticket number.
 *
 * An Indian Railways PNR is exactly 10 digits. The field used to accept unlimited free
 * text, so typos and pasted junk reached the database. Non-digits are stripped as they are
 * typed and the length is hard-capped, with a live counter so staff can see the count.
 */
const PnrInput = ({ value, onChange, error, disabled = false, id = 'pnr', label = 'PNR / Ticket Number' }) => {
  const digits = digitsOnly(value);
  const complete = digits.length === PNR_LENGTH;

  const handleChange = (e) => onChange(digitsOnly(e.target.value).slice(0, PNR_LENGTH));

  return (
    <FormField
      label={label}
      htmlFor={id}
      required
      error={error}
      hint={`${PNR_LENGTH}-digit number from the train ticket`}
    >
      <div className="relative">
        <CreditCard className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-midnight-400 pointer-events-none" />
        <input
          id={id}
          type="text"
          inputMode="numeric"
          autoComplete="off"
          value={digits}
          onChange={handleChange}
          disabled={disabled}
          maxLength={PNR_LENGTH}
          placeholder="1234567890"
          className={fieldClass(error, 'pl-10 pr-16 tracking-[0.15em] font-medium')}
        />
        <span className={`absolute right-3 top-1/2 -translate-y-1/2 flex items-center gap-1 text-xs font-medium ${
          complete ? 'text-green-600' : 'text-midnight-400'
        }`}>
          {complete && <Check className="w-3.5 h-3.5" />}
          {digits.length}/{PNR_LENGTH}
        </span>
      </div>
    </FormField>
  );
};

export default PnrInput;
